import { useSelector } from "react-redux";

import type { ResultsReduxState } from "@app/types/results-redux-types";

import type { TypedUseSelectorHook } from "react-redux";

export const useResultsSelector: TypedUseSelectorHook<ResultsReduxState> =
  useSelector;
